import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TenantContextService } from '../services/tenant-context.service';

/**
 * Roda **depois** do `authGuard`, **antes** de `/main`. Decide se o usuário
 * precisa escolher uma empresa:
 * - 0 empresas → segue (o app trata "sem empresa");
 * - 1 empresa → escolhe e segue;
 * - 2+ empresas: a escolha aponta para uma empresa **do usuário** → segue;
 *   senão → redireciona para `/selecionar-empresa` (página obrigatória, layout
 *   `blank`), que grava a escolha e volta para `/main`.
 *
 * Sempre aguarda `tenant.aguardarCarregado()` (a lista real do usuário logado)
 * antes de decidir — nunca com dado de sessão anterior. Valida a escolha contra
 * a lista: na troca de usuário na mesma aba o cookie pode reter o id de uma
 * empresa que não é do novo usuário.
 */
export const companySelectionGuard: CanActivateFn = async () => {
  const tenant = inject(TenantContextService);
  const router = inject(Router);

  const empresas = await tenant.aguardarCarregado();

  if (empresas.length === 0) {
    return true;
  }

  if (empresas.length === 1) {
    tenant.escolherEmpresa(empresas[0].id);
    return true;
  }

  const escolhidaId = tenant.empresaSelecionadaId;
  const escolhaValida = escolhidaId !== null && empresas.some(e => e.id === escolhidaId);
  if (escolhaValida) {
    return true;
  }

  if (escolhidaId !== null) {
    tenant.limparEmpresaSelecionada();
  }
  return router.parseUrl('/selecionar-empresa');
};
